import { GENDER_OPTIONS } from './GenderOptions'

const REGISTRAION_INPUTS_NAMES = {
    athlete: [
        { value: 'username', label: 'Username' },
        { value: 'email', label: 'Email' },
        { value: 'date', label: 'Date', type: 'date' },
        {
            value: 'gender',
            label: 'Gender',
            type: 'list',
            _options: GENDER_OPTIONS,
        },
    ],
}

const CONDITIONAL_DISPLAY_DEFAULT = {
    source: null,
    target: null,
    action: 'show',
    input: null,
    value: null,
}

export default {
    REGISTRAION_INPUTS_NAMES,
    CONDITIONAL_DISPLAY_DEFAULT,
}
